import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    universalVoucherServices_title:'Централизованная база данных подведомственных учреждений акимата Алматинской области',
  },
  kk: {
    universalVoucherServices_title:
      'Алматы облысы әкімдігінің ведомстволық бағыныстағы мекемелерінің орталықтандырылған деректер базасы',

  }
});
